import React from "react";
import { func, object, bool, arrayOf, shape, oneOfType, node, string } from "prop-types";
import { Grid, Button, Icon,  Responsive, Input } from 'semantic-ui-react'
import { translate, I18n } from 'react-i18next';
import {ButtonRow,  MaterialDropdown} from './Components'

const HeaderProps = {
  startEditing: func.isRequired,
  filter: object,
  loading: bool
};

const defaults = {
  loading: false,
  filters: []
};

let MobileFilterRows = (props) => {
  return props.filters.map((f, i) => <ButtonRow key={i}>{f}</ButtonRow>);
};


class MobileHeader extends React.PureComponent {
  static propTypes = HeaderProps;
  static defaultProps = defaults;
  state = {
    showFilter: false
  };

  render() {
    let { showFilter } = this.state;
    let { startEditing, filters, loading } = this.props;
    return <div><Responsive maxWidth={Responsive.onlyTablet.minWidth} as={ButtonRow} key="menu">
      <Button onClick={startEditing} disabled={loading} icon><Icon name="edit" color="green" /> </Button>
      <Button onClick={() => this.setState({ showFilter: !showFilter })} disabled={loading} icon="filter" />
    </Responsive>
      {showFilter && <MobileFilterRows filters={filters} />}
    </div>
  }
}

class DesktopHeader extends React.PureComponent {
  static propTypes = HeaderProps;
  static defaultProps = defaults;
  render() {
    let { startEditing, filters, loading, t } = this.props;
    return <Responsive minWidth={Responsive.onlyTablet.minWidth} as={ButtonRow}>
      <Button onClick={startEditing} disabled={loading} icon>
        <Icon name="edit" color="green" /> {t("edit")}
      </Button>
      {filters}
    </Responsive>
  }
}

/**
 * Shorthand for a filter input.
 * Just a name is needed, the type is string.
 * @type {Requireable<InferProps<{name: *}>>}
 */
export const FilterValue = shape({
  name: string
});
/**
 * Props to validate full dropdown values.
 * @type {Requireable<InferProps<{text: *, value: *}>>}
 */
const DropdownValues = shape({
  text: string.isRequired,
  value: string.isRequired
});
/**
 * A shorthand prop to declare a filter field.
 * Name of the filter: list of potential values.
 * Values can either be a list of strings or a list of {text, value} objects.
 * A list of strings is translated into a list of {text, value} automatically.
 * A list of test/value is left alone.
 */
export const FilterListItem = shape({
  name: string,
  values: arrayOf(oneOfType([string, DropdownValues]))
});

export const FilterNode = shape({
  name: string,
  field: node
});

let translateForDropDown = t => values => (
  values.map(v => {
    let {text, value} = v;
    if(text && value){
      return v;
    }
    return {
      text: t(v),
      value: v
    }
  })
);

export const CustomFilterTypes = arrayOf(oneOfType([
  FilterListItem, FilterValue, FilterNode
]));

const MapCustomFilters = ({ onFilterChange, loading, filter}) => (f) => {
  return (t) => {
    let {name, values, field} = f;
    let onChange = (e, {value}) => {
      onFilterChange({
        ...filter,
        [name]: value
      })
    };
    let placeholder = t(`fields.${name}.placeholder`);
    let value = filter[name];
    if (name && field) {
      let FilterField = field;
      return <FilterField value={value} placeholder={placeholder} onChange={onChange} disabled={loading} />;
    }
    if (name && values) {
      let translatedValues = translateForDropDown(t)(values);
      return <MaterialDropdown options={translatedValues} placeholder={placeholder} value={value} onChange={onChange} disabled={loading}/>
    }
    return <Input value={value} placeholder={placeholder} onChange={onChange} disabled={loading}/>
  }
};

let Localize = (Elem, i)  => {
  return <I18n key={i}>{ Elem }</I18n>
};

const CustomFilters = (props) => {
  let { filters } = props;
  let mapper = MapCustomFilters(props);
  return filters
    .map(mapper)
    .map(Localize);
};

CustomFilters.propTypes = CustomFilterTypes;

class DefaultHeader extends React.PureComponent {
  static propTypes = HeaderProps;
  static defaultProps = defaults;

  static CustomFilters = CustomFilters;

  render() {
    let { startEditing, loading, t, filters } = this.props;
    let childProps = {
      startEditing,
      loading,
      filters,
      t
    };
    return (<Grid style={{marginTop: 15}}>
      <DesktopHeader {...childProps} />
      <MobileHeader {...childProps} />
    </Grid>)
  }
}

export default translate()(DefaultHeader);
export { DefaultHeader, MobileHeader, MobileFilterRows, CustomFilters, MapCustomFilters };
